import { render, staticRenderFns } from "./invite-redbag.vue?vue&type=template&id=30fe932d&scoped=true&"
import script from "./invite-redbag.vue?vue&type=script&lang=js&"
export * from "./invite-redbag.vue?vue&type=script&lang=js&"
import style0 from "./invite-redbag.vue?vue&type=style&index=0&id=30fe932d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fe932d",
  null
  
)

export default component.exports